import { ReportSection } from '@/components/report/ReportSection';
import { BidCertaintyTable } from './BidCertaintyTable';
import { CampaignStructure } from './CampaignStructure';
import { LineKpisTable } from './LineKpisTable';
import { LineSpendChart } from './LineSpendChart';
import { TroubleshooterTable } from './TroubleshooterTable';
import type { DeliveryReport } from './types';

interface LinesTabProps {
  report: DeliveryReport;
}

export function LinesTab({ report }: LinesTabProps) {
  const { lines, exe } = report;
  const tsLabel = exe.ts_label;

  return (
    <div className="space-y-4">
      <ReportSection title="KPIs por línea" subtitle="acumulado · métricas del plan" count={lines.length}>
        <LineKpisTable report={report} />
      </ReportSection>

      <ReportSection title="Gasto diario vs tope diario">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {lines.map((line) => (
            <LineSpendChart key={line.id} line={line} />
          ))}
        </div>
      </ReportSection>

      <ReportSection title="Certeza de puja" subtitle="si bajamos la puja, ¿seguimos comprando?">
        <BidCertaintyTable lines={lines} troubleshooterLabel={tsLabel} />
      </ReportSection>

      <ReportSection
        title="Troubleshooter DV360"
        subtitle={tsLabel ? `${tsLabel} (días sumados)` : undefined}
        collapsible
        defaultOpen={false}
      >
        <TroubleshooterTable lines={lines} />
      </ReportSection>

      <ReportSection title="Estructura de campaña" subtitle="campaign → insertion order → line items" collapsible defaultOpen={false}>
        <CampaignStructure structure={report.structure} lines={lines} />
      </ReportSection>
    </div>
  );
}
